import {
  FaChartBar,
  FaChartLine,
  FaEnvelope,
  FaExchangeAlt,
  FaGlobe,
  FaMapMarkerAlt,
  FaPhone,
  FaUsers,
  FaWallet,
  FaRobot,
} from "react-icons/fa";

import Profile1 from "../images/avatars/1.jpg";
import Profile2 from "../images/avatars/2.jpg";
import Profile3 from "../images/avatars/3.jpg";

export const stats = [
  { label: "Assets Under Management", value: "$2.1B+" },
  { label: "Institutional Clients", value: "350+" },
  { label: "Global Reach", value: "60+ Countries" },
];

export const walletData = [
  {
    cardId: "institutional-accounts",
    title: "Institutional Accounts",
    icon: <FaWallet />,
    cryptoDetails: [
      { name: "Total Holdings", amount: "$1.8B", value: "Multi-asset custody" },
      {
        name: "Segregated Accounts",
        amount: "Yes",
        value: "Regulatory compliant",
      },
      {
        name: "Insurance Coverage",
        amount: "$250M",
        value: "Lloyd's of London",
      },
    ],
  },
  {
    cardId: "prime-brokerage",
    title: "Prime Brokerage",
    icon: <FaExchangeAlt />,
    cryptoDetails: [
      { name: "24h Volume", amount: "$320M", value: "Deep liquidity pools" },
      {
        name: "Execution Speed",
        amount: "<10ms",
        value: "Low-latency trading",
      },
      { name: "Supported Pairs", amount: "200+", value: "Global markets" },
    ],
  },
  {
    cardId: "portfolio-analytics",
    title: "Portfolio Analytics",
    icon: <FaChartLine />,
    cryptoDetails: [
      { name: "Total Value", amount: "$2.1B", value: "Across all strategies" },
      { name: "Best Performer", amount: "BTC", value: "+62.1% YTD" },
      { name: "Risk Adjusted Return", amount: "1.45", value: "Sharpe Ratio" },
    ],
  },
  {
    cardId: "mobile-platform",
    title: "Portfolio Dashboard Platform",
    icon: <FaChartLine />,
    cryptoDetails: [
      { name: "Actual Users Active", amount: "50K+", value: "Global access" },
      { name: "Daily Active", amount: "2K+", value: "Global access" },
      { name: "Platform Rating", amount: "4.5/5", value: "User reviews" },
    ],
  },
];

export const features = [
  {
    icon: <FaRobot />,
    title: "PROVEN TRADING BOT",
    description:
      "Our advanced scalping trading bot consistently delivers 37% average monthly returns with automated risk management.",
  },
  {
    icon: <FaExchangeAlt />,
    title: "INSTITUTIONAL OTC ACCESS",
    description:
      "Direct access to institutional OTC pricing and deep liquidity pools for optimal trade execution.",
  },
  {
    icon: <FaChartLine />,
    title: "COMPREHENSIVE MARKETS",
    description:
      "Trade cryptocurrencies and commodities markets with integrated portfolio management tools.",
  },
  {
    icon: <FaWallet />,
    title: "FLEXIBLE ACCOUNT TYPES",
    description:
      "Choose from 7 account tiers: Bronze, Silver, Gold, Platinum, Diamond, Elite, or Institutional — each with tailored features, exclusive benefits, and progressive CTE rewards.",
  },
];

export const accountTypes = [
  {
    type: "Retail",
    tiers: [
      {
        name: "Bronze",
        minDeposit: "$5,000",
        cteBonus: "10%",
        tierColor: "#00e7d4",
        benefits: 14,
        features: [
          "1 scalping session per week",
          "Basic CTE benefits",
          "Standard trading access",
          "Basic analytics dashboard",
          "Email support (24-48h response)",
          "AI Trading Assistant (Basic)",
          "Daily market updates",
          "Basic risk management tools",
          "Community forum access",
          "Monthly performance report",
        ],
        aiFeatures: [
          "Basic market analysis",
          "Simple trade suggestions",
          "Basic portfolio insights",
        ],
      },
      {
        name: "Silver",
        minDeposit: "$15,000",
        cteBonus: "15%",
        tierColor: "#00e7d4",
        benefits: 18,
        features: [
          "2 scalping sessions per week",
          "Enhanced CTE benefits",
          "Priority trading access",
          "Advanced analytics dashboard",
          "Priority email support (12-24h)",
          "AI Trading Assistant (Advanced)",
          "Real-time market alerts",
          "Advanced risk management",
          "Priority community access",
          "Bi-weekly performance reports",
          "Basic trading strategies library",
          "Portfolio optimization tools",
        ],
        aiFeatures: [
          "Advanced market analysis",
          "Personalized trade suggestions",
          "Advanced portfolio insights",
          "Risk assessment tools",
          "Market sentiment analysis",
        ],
      },
      {
        name: "Gold",
        minDeposit: "$25,000",
        cteBonus: "20%",
        tierColor: "#00e7d4",
        popular: true,
        benefits: 22,
        features: [
          "3 scalping sessions per week",
          "Premium CTE benefits",
          "VIP trading access",
          "Full analytics suite",
          "Priority chat & email support (4-12h)",
          "AI Trading Assistant (Premium)",
          "Real-time market intelligence",
          "Premium risk management suite",
          "VIP community & webinars",
          "Weekly performance reports",
          "Custom trading strategies",
          "Automated portfolio rebalancing",
          "Priority order execution",
        ],
        aiFeatures: [
          "Premium market analysis",
          "AI-powered trade suggestions",
          "Deep portfolio insights",
          "Advanced risk assessment",
          "Predictive market analysis",
          "Custom AI strategy development",
        ],
      },
      {
        name: "Platinum",
        minDeposit: "$50,000",
        cteBonus: "30%",
        tierColor: "#00e7d4",
        benefits: 26,
        features: [
          "4 scalping sessions per week",
          "Elite CTE benefits",
          "Platinum trading access",
          "Comprehensive analytics suite",
          "Dedicated support line (2-4h response)",
          "AI Trading Assistant (Elite)",
          "Exclusive market intelligence",
          "Institutional-grade risk management",
          "Platinum members lounge",
          "Daily performance reports",
          "Advanced algorithmic strategies",
          "Smart portfolio rebalancing",
          "Ultra-low latency execution",
          "Access to IPO & pre-sales",
        ],
        aiFeatures: [
          "Elite market analysis & predictions",
          "AI-powered trade execution",
          "Comprehensive portfolio management",
          "Predictive risk modeling",
          "Sentiment & social analysis",
          "Custom algorithm development",
          "Multi-asset correlation insights",
        ],
      },
      {
        name: "Diamond",
        minDeposit: "$100,000",
        cteBonus: "40%",
        tierColor: "#00e7d4",
        benefits: 32,
        features: [
          "5 scalping sessions",
          "Maximum CTE benefits",
          "Diamond priority access",
          "Enterprise analytics suite",
          "Personal account manager",
          "AI Trading Assistant (Enterprise)",
          "Proprietary market research",
          "Advanced hedging strategies",
          "Diamond exclusive events",
          "Real-time performance dashboard",
          "Institutional trading algorithms",
          "Tax optimization strategies",
          "Direct market access (DMA)",
          "Early access to new features",
          "Quarterly dividend participation",
        ],
        aiFeatures: [
          "Enterprise-grade AI analysis",
          "Autonomous trade execution",
          "Institutional portfolio optimization",
          "Advanced predictive modeling",
          "Cross-market arbitrage detection",
          "Custom AI model training",
          "Real-time strategy optimization",
          "Multi-strategy AI execution",
        ],
      },
      {
        name: "Elite",
        minDeposit: "$175,000",
        cteBonus: "50%",
        tierColor: "#00e7d4",
        benefits: 40,
        features: [
          "6 scalping sessions",
          "Maximum CTE benefits + bonuses",
          "Elite white-glove service",
          "Dedicated relationship manager",
          "AI Trading Assistant (Elite Pro)",
          "Exclusive alpha research",
          "OTC trading desk access",
          "Elite mastermind group",
          "Live performance analytics",
          "Proprietary trading systems",
          "Estate & wealth planning",
          "Prime brokerage services",
          "Board advisory opportunities",
          "Quarterly dividends + profit sharing",
          "Second account for long-term holdings",
        ],
        aiFeatures: [
          "Elite Pro AI with priority processing",
          "Fully autonomous portfolio management",
          "Institutional-grade risk modeling",
          "Exclusive signal generation",
          "Custom high-frequency strategies",
          "Real-time market manipulation detection",
          "Multi-exchange arbitrage execution",
          "Private AI model customization",
        ],
      },
    ],
  },
  {
    type: "Institutional",
    minDeposit: "$300,000",
    cteBonus: "60%",
    tierColor: "#00e7d4",
    benefits: 50,
    features: [
      "7 scalping sessions",
      "Maximum CTE benefits + enhanced bonuses",
      "Quarterly dividends + profit sharing",
      "Multiple account access (up to 5)",
      "Dedicated scalping account",
      "Long/short investment accounts",
      "Hedge fund-grade CTE benefits",
      "Institutional OTC desk (24/7)",
      "Offshore banking solutions",
      "Custom trading infrastructure",
      "Dedicated institutional team",
      "AI Trading Assistant (Institutional)",
      "Bloomberg terminal access",
      "Custom API & integration",
      "Direct market access (all exchanges)",
      "Co-location services available",
      "Multi-account management suite",
      "Bank-grade security protocols",
      "Regulatory compliance support",
    ],
    aiFeatures: [
      "Institutional-grade AI infrastructure",
      "Multi-billion dollar portfolio management",
      "Enterprise risk modeling & VaR",
      "Predictive analytics suite",
      "Custom AI strategy implementation",
      "Real-time trade optimization",
      "Multi-strategy AI execution",
      "Institutional research & alpha generation",
      "Market microstructure analysis",
      "Custom machine learning models",
    ],
    additionalBenefits: [
      "Dedicated relationship manager & team",
      "Custom integration & API support",
      "Institutional research reports (weekly)",
      "Priority access to all new features",
      "Institutional-grade security audit",
      "Full compliance & regulatory support",
      "Annual strategy review with C-suite",
      "Exclusive institutional events & conferences",
      "Board advisory & networking opportunities",
      "White-label solutions available",
    ],
  },
];

export const cryptoData = [
  {
    name: "BTC",
    subname: "Bitcoin",
    blockchain: "Bitcoin",
    liquidityRate: "98.2%",
    tokensLocked: "N/A",
    valueLocked: "$1.1B",
    nextUnlock: "N/A",
    marketCap: "$1.3T",
    volume24h: "$32.5B",
    priceChange: "+2.3%",
    riskLevel: "Low",
  },
  {
    name: "ETH",
    subname: "Ethereum",
    blockchain: "Ethereum",
    liquidityRate: "95.7%",
    tokensLocked: "N/A",
    valueLocked: "$650M",
    nextUnlock: "N/A",
    marketCap: "$480B",
    volume24h: "$18.2B",
    priceChange: "+1.8%",
    riskLevel: "Low",
  },
  {
    name: "USDC",
    subname: "USD Coin",
    blockchain: "Ethereum",
    liquidityRate: "100.0%",
    tokensLocked: "N/A",
    valueLocked: "$210M",
    nextUnlock: "N/A",
    marketCap: "$32B",
    volume24h: "$5.1B",
    priceChange: "0.0%",
    riskLevel: "Low",
  },
  {
    name: "SOL",
    subname: "Solana",
    blockchain: "Solana",
    liquidityRate: "89.4%",
    tokensLocked: "N/A",
    valueLocked: "$95M",
    nextUnlock: "N/A",
    marketCap: "$68B",
    volume24h: "$2.7B",
    priceChange: "+4.1%",
    riskLevel: "Medium",
  },
  {
    name: "ARB",
    subname: "Arbitrum",
    blockchain: "Arbitrum",
    liquidityRate: "80.2%",
    tokensLocked: "N/A",
    valueLocked: "$40M",
    nextUnlock: "N/A",
    marketCap: "$12B",
    volume24h: "$1.2B",
    priceChange: "+0.9%",
    riskLevel: "Medium",
  },
];

export const blockchains = ["All", "Bitcoin", "Ethereum", "Solana", "Arbitrum"];

export const states = [
  {
    number: "$2.1B+",
    label: "Assets Managed",
    icon: <FaChartBar />,
    description: "Trusted by institutions worldwide",
    growth: "+18% YoY",
  },
  {
    number: "350+",
    label: "Institutional Clients",
    icon: <FaUsers />,
    description: "Banks, funds, and family offices",
    growth: "+22% YoY",
  },
  {
    number: "60+",
    label: "Countries Served",
    icon: <FaGlobe />,
    description: "Global regulatory coverage",
    growth: "Expanding rapidly",
  },
];

export const trendingTopics = [
  { id: 1, title: "Digital Asset Custody", posts: 98 },
  { id: 2, title: "Prime Brokerage Trends", posts: 87 },
  { id: 3, title: "Institutional DeFi", posts: 74 },
  { id: 4, title: "Crypto Regulation", posts: 65 },
];

export const testimonials = [
  {
    id: 1,
    content:
      "Airclift Capital's platform is the gold standard for institutional crypto services. Their security and execution are unmatched.",
    author: {
      name: "Linda Zhang",
      role: "Portfolio Manager, Alpha Fund",
      avatar: Profile1,
    },
    rating: 5,
  },
  {
    id: 2,
    content:
      "We trust Airclift Capital for all our digital asset needs. Their team is responsive, knowledgeable, and always puts clients first.",
    author: {
      name: "James Carter",
      role: "CIO, Zenith Family Office",
      avatar: Profile2,
    },
    rating: 5,
  },
  {
    id: 3,
    content:
      "The analytics and reporting tools are best-in-class. Airclift Capital makes institutional crypto investing seamless.",
    author: {
      name: "Tessa Noor",
      role: "Head of Research, Quantum Investments",
      avatar: Profile3,
    },
    rating: 5,
  },
];

export const contactInfo = [
  {
    icon: <FaEnvelope />,
    title: "Email",
    info: "support@aircliftcapital.com",
    link: "mailto:contact@airclift.com",
  },
  {
    icon: <FaPhone />,
    title: "Phone",
    info: "+1 (866) 739-1865",
    link: "tel:+18667391865",
  },
  {
    icon: <FaMapMarkerAlt />,
    title: "Headquarters",
    info: "65 Davies, Street, Mayfair, London, UK",
    link: "https://www.google.com/maps?q=65+Davies+Street,+Mayfair,+London,+UK",
  },
];

export const footerLinks = {
  Company: {
    About: ["Leadership", "Press"],
    Support: ["Contact", "Help Center", "Security", "Compliance"],
    Legal: [
      "Terms of Service",
      "Privacy Policy",
      "Regulatory Disclosures",
      "Cookie Policy",
    ],
  },
};
export const socialLinks = [
  // {
  //   icon: <FaTwitter />,
  //   url: "https://twitter.com/aircliftcapital",
  //   name: "Twitter",
  // },
  // {
  //   icon: <FaTelegram />,
  //   url: "https://t.me/aircliftcapital",
  //   name: "Telegram",
  // },
];

export const serviceData = [
  {
    icon: <FaGlobe />,
    title: "GLOBAL REACH",
    description:
      "Serving institutional clients in 20+ countries with custom support.",
  },
  {
    icon: <FaChartBar />,
    title: "INSTITUTIONAL ANALYTICS",
    description:
      "Comprehensive analytics and reporting for compliance and performance.",
  },
];
